/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { SegmentedControl } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [selectedSmall, setSelectedSmall] = useState('small1');
  const [selectedMedium, setSelectedMedium] = useState('medium1');
  const [selectedLarge, setSelectedLarge] = useState('large1');

  return (
    <div className="n-flex n-gap-token-16">
      <SegmentedControl
        selected={selectedSmall}
        onChange={setSelectedSmall}
        size="small"
      >
        <SegmentedControl.Item value="small1">Small 1</SegmentedControl.Item>
        <SegmentedControl.Item value="small2">Small 2</SegmentedControl.Item>
        <SegmentedControl.Item value="small3">Small 3</SegmentedControl.Item>
      </SegmentedControl>

      <SegmentedControl
        selected={selectedMedium}
        onChange={setSelectedMedium}
        size="medium"
      >
        <SegmentedControl.Item value="medium1">Medium 1</SegmentedControl.Item>
        <SegmentedControl.Item value="medium2">Medium 2</SegmentedControl.Item>
        <SegmentedControl.Item value="medium3">Medium 3</SegmentedControl.Item>
      </SegmentedControl>

      <SegmentedControl
        selected={selectedLarge}
        onChange={setSelectedLarge}
        size="large"
      >
        <SegmentedControl.Item value="large1">Large 1</SegmentedControl.Item>
        <SegmentedControl.Item value="large2">Large 2</SegmentedControl.Item>
        <SegmentedControl.Item value="large3">Large 3</SegmentedControl.Item>
      </SegmentedControl>
    </div>
  );
};

export default Component;
